import ApiCategory from '@/api/Category'
import RequestMixin from '@/mixins/request'

export default {
    mixins: [RequestMixin],
    data () {
        return {
            categories: []
        }
    },
    methods: {
        loadCategories () {
            return this.performRequest(ApiCategory.getCategories(this.$axios), { handle404: false })
                .then(response => {
                    this.categories = response.data
                })
                .catch(error => {
                    console.error(error)
                    this.categories = []
                })
        }
    }
}